import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { AlignCenter } from '../../../../global/commonStyle';

interface Props {
  isDisabled?: boolean;
}

const ReactionDivWrapper = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
  width: max-content;
  margin: -4px var(--space-0) var(--space-0) var(--space-8);
  z-index: var(--z-index-base);
  ${mobile_xl(css`
    margin-top: -10px;
  `)}
`;

const ReactionShow = styled.div<Props>`
  border: 1px solid var(--background-secondary);
  background-color: var(--background-active-navbar);
  border-radius: var(--border-radius-full);
  padding: var(--space-2) var(--space-8);
  ${AlignCenter}
  gap: var(--space-4);
  width: fit-content;
  &:hover {
    cursor: pointer;
  }
  .reaction-icon {
    font-size: 13px;
    line-height: 16px;
  }
  p {
    ${Typography.body_md};
    color: var(--text-primary);
    margin: var(--space-0);
  }
  ${mobile_xl(css`
    gap: var(--space-5);
  `)}
  ${(props) =>
    props.isDisabled &&
    `
      pointer-events: none;
    `}
`;

export { ReactionDivWrapper, ReactionShow };
